/**
 * Promo Slideshow / Hot This Week Component - Sleek Theme OS 2.0
 */
if (!customElements.get('promo-slideshow')) {
  class PromoSlideshow extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.slides = this.querySelectorAll('[data-slide]');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
    }

    connectedCallback() {
      if (!this.track || this.totalSlides <= 1) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.slidePrev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.slideNext());
      }

      this.updateControls();
    }

    slidePrev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlidePosition();
      }
    }

    slideNext() {
      const visibleCount = window.innerWidth >= 768 ? 2 : 1;
      const maxIndex = Math.max(0, this.totalSlides - visibleCount);
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // loop
      }
      this.updateSlidePosition();
    }

    updateSlidePosition() {
      if (!this.track) return;
      const slideWidth = this.slides[0]?.offsetWidth || 0;
      const gap = 24; // 1.5rem
      const offset = this.currentIndex * (slideWidth + gap);
      this.track.style.transform = `translateX(-${offset}px)`;
      this.updateControls();
    }

    updateControls() {
      const visibleCount = window.innerWidth >= 768 ? 2 : 1;
      const maxIndex = Math.max(0, this.totalSlides - visibleCount);

      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= maxIndex && maxIndex > 0;
      }
    }
  }

  customElements.define('promo-slideshow', PromoSlideshow);
}
